import { render, staticRenderFns } from "./CardioChirurgiaEditComponent.vue?vue&type=template&id=4a5b29fd&scoped=true"
import script from "./CardioChirurgiaEditComponent.vue?vue&type=script&lang=js"
export * from "./CardioChirurgiaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CardioChirurgiaEditComponent.vue?vue&type=style&index=0&id=4a5b29fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b29fd",
  null
  
)

export default component.exports